module.exports = __webpack_public_path__ + "static/media/cryptopunks.2bfe3833.jpg";